import { CloseIcon } from "vega-icons";

import { ThemedIconButton } from "@vega-core/components/Buttons/ThemedIconButton";
import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

export const ThemedModalCloseButton = ({
  className,
  onClose,
  disabled,
}: {
  className?: string;
  onClose: () => void;
  disabled?: boolean;
}) => (
  <ThemedIconButton
    ariaLabel={m.btn_close()}
    className={cnTwMerge(
      "top-3 right-3 rounded-full bg-background/tertiary absolute w-8 h-8",
      className,
    )}
    dataTestId="modal-close-button"
    disabled={disabled}
    icon={<CloseIcon className="text-text/primary" />}
    onClick={onClose}
    variant="noBackground"
  />
);
